import React, { SVGProps } from 'react'

const ArrowRight = (props: SVGProps<SVGGElement>) => {
  const { fill = '#FFFFFF' } = props

  return (
    <svg
      width='18px'
      height='14px'
      viewBox='0 0 18 14'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <path
          d='M158.789889,31.6017435 L171.727561,31.6017435 C173.180656,31.6017435 173.180656,29.3879943 171.727561,29.3879943 L158.789889,29.3879943 L162.318118,25.9288543 C163.355648,24.8913265 161.764482,23.2995581 160.726952,24.3376928 L155.399802,29.6648289 C154.91521,30.079697 154.846166,30.8411042 155.330772,31.3250158 L160.727537,36.7217666 C161.765068,37.7592938 163.287226,36.168133 162.249659,35.1306057 L158.79051,31.6023864 L158.789889,31.6017435 Z'
          id='path-1'></path>
        <filter
          x='-2.8%'
          y='-3.8%'
          width='105.6%'
          height='115.3%'
          filterUnits='objectBoundingBox'
          id='filter-2'>
          <feOffset
            dx='0'
            dy='1'
            in='SourceAlpha'
            result='shadowOffsetOuter1'></feOffset>
          <feComposite
            in='shadowOffsetOuter1'
            in2='SourceAlpha'
            operator='out'
            result='shadowOffsetOuter1'></feComposite>
          <feColorMatrix
            values='0 0 0 0 0.317647059   0 0 0 0 0.325490196   0 0 0 0 0.368627451  0 0 0 1 0'
            type='matrix'
            in='shadowOffsetOuter1'></feColorMatrix>
        </filter>
      </defs>
      <g
        id='V0.3-July-20'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'>
        <g
          id='Assessment---Designer-Q&amp;A'
          transform='translate(-1091.000000, -224.000000)'>
          <g
            id='Frame-1---assessment,-stats-and-results'
            transform='translate(360.000000, 72.000000)'>
            <g
              id='Tile---Not-Detrmined'
              transform='translate(552.000000, 24.000000)'>
              <g id='Button' transform='translate(24.000000, 104.000000)'>
                <g
                  id='Arrow'
                  transform='translate(163.908691, 30.529606) scale(-1, 1) translate(-163.908691, -30.529606) '>
                  <use
                    fill='black'
                    fill-opacity='1'
                    filter='url(#filter-2)'
                    xlinkHref='#path-1'></use>
                  <use fill={fill} fillRule='evenodd' xlinkHref='#path-1'></use>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default ArrowRight
